// removed by extract-text-webpack-plugin
module.exports = {"link":"plain-link__link___FIrE5"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/link/plain-link.css
// module id = 1180
// module chunks = 0